import React from 'react';
import logo from '../../assets/images/site/mobiliis-logo.png';
import { SITE_URL, EMAIL_ENCODED, COMPANY_LINE, revealEmail } from './siteLinks';

/**
 * The public pages' footer: the main website's own (www.mobiliis.com), the same markup and styles (site.scss): the
 * white logo, "Show our email address" (the address appears only after a click, as there), the link to
 * www.mobiliis.com, the copyright line, and the company line (also added to the updated main website).
 */
class SiteFooter extends React.Component {
	constructor(props) {
		super(props);
		this.state = { email: null };
	}

	render() {
		const { email } = this.state;
		return (
			<footer className="site-footer">
				<div className="wrap footer-inner">
					<img src={logo} alt="Mobiliis" className="footer-logo" />
					<div className="footer-links">
						{email
							? <span className="email-revealed">{email}</span>
							: <button type="button" className="email-reveal" onClick={() => this.setState({ email: revealEmail(EMAIL_ENCODED) || null })}>
								Show our email address
							</button>}
						<a href={SITE_URL}>www.mobiliis.com</a>
					</div>
					<p className="footer-copy">&copy; {new Date().getFullYear()} Mobiliis. Mobile eyes for the mobile age.</p>
					<p className="footer-company">{COMPANY_LINE}</p>
				</div>
			</footer>
		);
	}
}

export default SiteFooter;
